/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'charts': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M1024 896v128H0V0h128v440.64l278.72-183.872 14.016 20.8 8.704-6.912 208.512 257.856 310.4-204.8 75.136 111.488L617.28 703.168l-14.016-20.8-8.704 6.912-208.512-257.92L128 601.6V896h896z"/>'
  }
})
